const language = (window.language && window.language.toLocaleLowerCase()) || 'es';
const country = (window.country && window.country.toLocaleLowerCase()) || 'ar';

export default {
    es_ar: {
        api_error_message: 'Lo sentimos, se ha producido un error al intentar procesar su consulta. Por favor, vuelva a intentar en unos minutos.',
        accept_error_btn: 'Aceptar',
        client_number: 'Número de cliente en Booking.com',
        property_name: 'Nombre de la propiedad',
        holder_name: 'Nombre de propietario de cuenta bancaria',
        document: 'CUIL/CUIT de la Propiedad',
        document2: 'CBU',
        email: 'Email',
        invoice_number: 'Número de factura',
        amount: 'Monto (pesos argentinos)',
        bank_origin: 'Banco origen',
        voucher: 'Comprobante de pago',
        important: 'Importante',
        payment_disclaimer_1: 'EL pago por transferencia bancaria es un proceso que consta de dos pasos obligatorios',
        payment_disclaimer_2: 'Completar los datos del formulario y presionar enviar.',
        payment_disclaimer_3:
            'Usted tendrá un máximo de 3 horas para poder realizar la transferencia a través de su home banking o depósito con los datos que se muestran en la pantalla. Hasta tanto, la factura permanecerá impaga.',
        step: 'Paso',
        invoice_disclaimer: 'Puedes ingresar múltiples facturas separadas por coma (máximo 10 facturas)',
        terms_1: 'Acepto los',
        terms_2: ' Términos y Condiciones',
        close: 'Cerrar',
        send: 'Enviar',
        claim_bank_transfer_disclaimer:
            'Tenga en cuenta que para su próximo pago deberá ingresar la solicitud de pago antes de realizar\n la transferencia.',
        make_transfer_disclaimer: 'Realice la transferencia en las próximas tres horas.',
        read_transfer_disclaimer_1: 'Lea atentamente los datos de la transferencia.',
        read_transfer_disclaimer_2: 'Sugerimos realizar los depósitos a través de online banking.',
        read_transfer_disclaimer_3:
            'La transferencia bancaria se procesará en el siguiente día hábil bancario, una vez procesada, Booking.com será notificado al segundo día hábil bancario.',
        reference: 'Referencia',
        bank: 'Banco',
        beneficiary: 'Beneficiario',
        entity_document: 'CUIT',
        alias: 'ALIAS',
        account_type: 'Tipo de cuenta',
        account: 'Cuenta',
        make_transfer: 'Realizar transferencia',
        transfer_data: 'Datos de la transferencia',
        amount_usd: 'Monto',
        claim_sended: 'El reclamo fue enviado con éxito.',
        will_redirect: 'Será redireccionado en instantes...',
        payment_form: 'Formulario de pago',
        payment_choice: 'Seleccione la opción de pago:',
        error_conditions: 'Debes aceptar los términos y condiciones  para continuar',
        form_validation: {
            only_numbers: 'Este campo sólo puede contener números',
            min_five_characters: 'Este campo debe tener un mínimo de 5 caracteres',
            must_be_ten_digits: 'Los números de factura deben ser de 10 dígitos',
            amount_higher_than_zero: 'El monto debe ser mayor a 0',
            amount_exceeded: 'El monto por factura no debe superar los $',
            name_max_characters: 'El nombre es demasiado largo, debe ser menor a 100 caracteres',
            format: 'Error de formato',
            property_name_max_characters: 'El nombre es demasiado largo, debe ser menor a 100 caracteres',
        },
        download_manual: 'Descargar manual',
        collect: 'recauda los fondos en nombre de Booking.com.',
        continue: 'Continuar',
        card: {
            tab_title: "Tarjeta de crédito",
            title: "Pago con tarjeta de crédito",
            booking_client: "Número de cliente en booking.com",
            booking_client_placeholder: "Ingrese de 5 a 8 dígitos",
            hotel_name: "Nombre del hotel",
            document: "NIT",
            email: "Email",
            billing_title: "Facturas a pagar",
            billing_description: "Puedes pagar hasta 10 facturas al mismo tiempo. El monto máximo a pagar por factura es de ",
            currency_local: " pesos argentinos.",
            invoice_id_label: "Número de factura",
            invoice_amount_label: "Monto (COP)",
            invoice_id_placeholder: "Ingrese 10 dígitos",
            invoice_amount_placeholder: "$",
            add_invoice: "Agregar nueva factura",
            inputs_required: "Todos los campos del formulario son obligatorios.",
            total_amount: "Monto total",
            remove_tooltip: "Quitar esta factura",
            amount: {
                max: 'El monto no debe exceder los $2.000.000',
                min: 'El monto no debe ser inferior a $100'
            },
            document_min_characters: "Error de formato",
            document_max_characters: "Error de formato",
            errorSaveForm: "Se ha producido un error, por favor, intenta nuevamente.",
            document_placeholder: "Ingrese todos los dígitos juntos sin espacios, guiones, puntos ni comas e incluya el último dígito verificador"
        },
        cardPayment: {
            pay: "Pagar",
            title: "Pago con tarjeta de crédito",
            messageSuccess: 'Tu pago se completó con éxito.',
            messageError: 'Ocurrió un error, por favor intentá nuevamente.',
            returnButton: 'Volver a gestión de pagos',
            close: 'Cerrar',
            name: {
              placeholder: "Carlos García",
              label: "Nombre del titular de la tarjeta",
              invalid: "",
              required: "",
            },
            pan: {
              label: "Número de tarjeta",
              placeholder: "",
              invalid: "Los datos ingresados no son correctos.",
              required: "Debes completar este campo correctamente.",
            },
            cvv: {
              label: "Código de seguridad",
              placeholder: "",
              invalid: "",
              required: "Debes completar este campo.",
            },
            expiration: {
              label: "Fecha de vencimiento",
              placeholder: "",
              invalid: "",
              required: "Debes completar este campo.",
            }
          },
          bank_transfer: {
            checking: 'Cuenta corriente',
            saving: 'Caja de ahorro'
          }
    },
    es_co: {
        api_error_message: 'Lo sentimos, se ha producido un error al intentar procesar su consulta. Por favor, vuelva a intentar en unos minutos.',
        accept_error_btn: 'Aceptar',
        client_number: 'Número de cliente en Booking.com',
        property_name: 'Nombre de la propiedad',
        holder_name: 'Nombre del titular de la cuenta bancaria',
        document: 'ID',
        email: 'Email',
        invoice_number: 'Número de factura',
        amount: 'Monto (pesos colombianos)',
        bank_origin: 'Banco origen',
        voucher: 'Comprobante de pago',
        important: 'Importante',
        payment_disclaimer_1: 'EL pago por transferencia bancaria es un proceso que consta de dos pasos obligatorios',
        payment_disclaimer_2: 'Completar los datos del formulario y presionar enviar.',
        payment_disclaimer_3:
            'Usted tendrá un máximo de 3 horas para poder realizar la transferencia a través de su home banking o depósito con los datos que se muestran en la pantalla. Hasta tanto, la factura permanecerá impaga.',
        step: 'Paso',
        invoice_disclaimer: 'Puedes ingresar múltiples facturas separadas por coma (máximo 10 facturas)',
        terms_1: 'Acepto los',
        terms_2: ' Términos y Condiciones',
        close: 'Cerrar',
        send: 'Enviar',
        claim_bank_transfer_disclaimer:
            'Tenga en cuenta que para su próximo pago deberá ingresar la solicitud de pago antes de realizar\n la transferencia.',
        make_transfer_disclaimer: 'Realice la transferencia en las próximas tres horas.',
        read_transfer_disclaimer_1: 'Lea atentamente los datos de la transferencia.',
        read_transfer_disclaimer_2: 'Sugerimos realizar los depósitos a través de online banking.',
        read_transfer_disclaimer_3:
            'La transferencia bancaria se procesará en el siguiente día hábil bancario, una vez procesada, Booking.com será notificado al segundo día hábil bancario.',
        reference: 'Referencia',
        bank: 'Banco',
        beneficiary: 'Beneficiario',
        entity_document: 'ID',
        account_type: 'Tipo de cuenta',
        account: 'Cuenta',
        make_transfer: 'Realizar transferencia',
        transfer_data: 'Datos de la transferencia',
        amount_usd: 'Monto',
        claim_sended: 'El reclamo fue enviado con éxito.',
        will_redirect: 'Será redireccionado en instantes...',
        payment_form: 'Formulario de pago',
        payment_choice: 'Seleccione la opción de pago:',
        form_validation: {
            only_numbers: 'Este campo sólo puede contener números',
            min_five_characters: 'Este campo debe tener un mínimo de 5 caracteres',
            must_be_ten_digits: 'Los números de factura deben ser de 10 dígitos',
            amount_higher_than_zero: 'El monto debe ser mayor a 0',
            email: 'El formato de email no es correcto',
            length_booking_client: 'Debe tener entre 5 y 8 caracteres',
            amount_exceeded: 'El monto por factura no debe superar los $',
            name_max_characters: 'El nombre es demasiado largo, debe ser menor a 100 caracteres',
            format: 'Error de formato',
            property_name_max_characters: 'El nombre es demasiado largo, debe ser menor a 100 caracteres',
        },
        download_manual: 'Descargar manual',
        collect: 'recauda los fondos en nombre de Booking.com.',
        continue: 'Continuar',
        card: {
            tab_title: "Tarjeta de crédito",
            title: "Pago con tarjeta de crédito",
            booking_client: "Número de cliente en booking.com",
            booking_client_placeholder: "Ingrese de 5 a 8 dígitos",
            hotel_name: "Nombre del hotel",
            document: "NIT",
            email: "Email",
            billing_title: "Facturas a pagar",
            billing_description: "Puedes pagar hasta 10 facturas al mismo tiempo. El monto máximo a pagar por factura es de ",
            currency_local: " pesos colombianos.",
            invoice_id_label: "Número de factura",
            invoice_amount_label: "Monto (COP)",
            invoice_id_placeholder: "Ingrese 10 dígitos",
            invoice_amount_placeholder: "$",
            add_invoice: "Agregar nueva factura",
            inputs_required: "Todos los campos del formulario son obligatorios.",
            total_amount: "Monto total",
            remove_tooltip: "Quitar esta factura",
            amount: {
                max: 'El monto no debe exceder los $2.000.000',
                min: 'El monto no debe ser inferior a $100'
            },
            document_min_characters: "Error de formato",
            document_max_characters: "Error de formato",
            errorSaveForm: "Se ha producido un error, por favor, intenta nuevamente.",
            document_placeholder: "Ingrese todos los dígitos juntos sin espacios, guiones, puntos ni comas e incluya el último dígito verificador"
        },
        cardPayment: {
            pay: "Pagar",
            title: "Pago con tarjeta de crédito",
            messageSuccess: 'Tu pago se completó con éxito.',
            messageError: 'Ocurrió un error, por favor intentá nuevamente.',
            returnButton: 'Volver a gestión de pagos',
            close: 'Cerrar',
            name: {
              placeholder: "Carlos García",
              label: "Nombre del titular de la tarjeta",
              invalid: "",
              required: "",
            },
            pan: {
              label: "Número de tarjeta",
              placeholder: "",
              invalid: "Los datos ingresados no son correctos.",
              required: "Debes completar este campo correctamente.",
            },
            cvv: {
              label: "Código de seguridad",
              placeholder: "",
              invalid: "",
              required: "Debes completar este campo.",
            },
            expiration: {
              label: "Fecha de vencimiento",
              placeholder: "",
              invalid: "",
              required: "Debes completar este campo.",
            }
          },
          bank_transfer: {
            checking: 'Cuenta corriente',
            saving: 'Caja de ahorro'
          }
    },
    es_cl: {
        api_error_message: 'Lo sentimos, se ha producido un error al intentar procesar su consulta. Por favor, vuelva a intentar en unos minutos.',
        accept_error_btn: 'Aceptar',
        client_number: 'Número de cliente en Booking.com',
        property_name: 'Nombre de la propiedad',
        holder_name: 'Nombre del titular de la cuenta bancaria',
        document: 'RUT',
        email: 'Email',
        invoice_number: 'Número de factura',
        amount: 'Monto (pesos chilenos)',
        bank_origin: 'Banco origen',
        voucher: 'Comprobante de pago',
        important: 'Importante',
        payment_disclaimer_1: 'EL pago por transferencia bancaria es un proceso que consta de dos pasos obligatorios',
        payment_disclaimer_2: 'Completar los datos del formulario y presionar enviar.',
        payment_disclaimer_3:
            'Usted tendrá un máximo de 3 horas para poder realizar la transferencia a través de su home banking o depósito con los datos que se muestran en la pantalla. Hasta tanto, la factura permanecerá impaga.',
        step: 'Paso',
        invoice_disclaimer: 'Puedes ingresar múltiples facturas separadas por coma (máximo 10 facturas)',
        terms_1: 'Acepto los',
        terms_2: ' Términos y Condiciones',
        close: 'Cerrar',
        send: 'Enviar',
        claim_bank_transfer_disclaimer:
            'Tenga en cuenta que para su próximo pago deberá ingresar la solicitud de pago antes de realizar\n la transferencia.',
        make_transfer_disclaimer: 'Realice la transferencia en las próximas tres horas.',
        read_transfer_disclaimer_1: 'Lea atentamente los datos de la transferencia.',
        read_transfer_disclaimer_2: 'Sugerimos realizar los depósitos a través de online banking.',
        read_transfer_disclaimer_3:
            'La transferencia bancaria se procesará en el siguiente día hábil bancario, una vez procesada, Booking.com será notificado al segundo día hábil bancario.',
        reference: 'Referencia',
        bank: 'Banco',
        beneficiary: 'Beneficiario',
        entity_document: 'RUT',
        account_type: 'Tipo de cuenta',
        account: 'Cuenta',
        make_transfer: 'Realizar transferencia',
        transfer_data: 'Datos de la transferencia',
        amount_usd: 'Monto',
        claim_sended: 'El reclamo fue enviado con éxito.',
        will_redirect: 'Será redireccionado en instantes...',
        payment_form: 'Formulario de pago',
        payment_choice: 'Seleccione la opción de pago:',
        form_validation: {
            only_numbers: 'Este campo sólo puede contener números',
            min_five_characters: 'Este campo debe tener un mínimo de 5 caracteres',
            must_be_ten_digits: 'Los números de factura deben ser de 10 dígitos',
            amount_higher_than_zero: 'El monto debe ser mayor a 0',
            email: 'El formato de email no es correcto',
            length_booking_client: 'Debe tener entre 5 y 8 caracteres',
            amount_exceeded: 'El monto por factura no debe superar los $',
            name_max_characters: 'El nombre es demasiado largo, debe ser menor a 100 caracteres',
            format: 'Error de formato',
            property_name_max_characters: 'El nombre es demasiado largo, debe ser menor a 100 caracteres',
        },
        download_manual: 'Descargar manual',
        collect: 'recauda los fondos en nombre de Booking.com.',
        continue: 'Continuar',
        card: {
            tab_title: "Tarjeta de crédito",
            title: "Pago con tarjeta de crédito",
            booking_client: "Número de cliente en booking.com",
            booking_client_placeholder: "Ingrese de 5 a 8 dígitos",
            hotel_name: "Nombre del hotel",
            document: "RUT",
            email: "Email",
            billing_title: "Facturas a pagar",
            billing_description: "Puedes pagar hasta 10 facturas al mismo tiempo. El monto máximo a pagar por factura es de ",
            currency_local: " pesos chilenos.",
            invoice_id_label: "Número de factura",
            invoice_amount_label: "Monto (CLP)",
            invoice_id_placeholder: "Ingrese 10 dígitos",
            invoice_amount_placeholder: "$",
            add_invoice: "Agregar nueva factura",
            inputs_required: "Todos los campos del formulario son obligatorios.",
            total_amount: "Monto total",
            remove_tooltip: "Quitar esta factura",
            amount: {
                max: 'El monto no debe exceder los $2.000.000',
                min: 'El monto no debe ser inferior a $50'
            },
            document_min_characters: "Error de formato",
            document_max_characters: "Error de formato",
            errorSaveForm: "Se ha producido un error, por favor, intenta nuevamente.",
            document_placeholder: "Ingrese todos los dígitos juntos sin espacios, guiones, puntos ni comas e incluya el último dígito verificador"
        },
        cardPayment: {
            pay: "Pagar",
            title: "Pago con tarjeta de crédito",
            messageSuccess: 'Tu pago se completó con éxito.',
            messageError: 'Ocurrió un error, por favor intentá nuevamente.',
            returnButton: 'Volver a gestión de pagos',
            close: 'Cerrar',
            name: {
              placeholder: "Carlos García",
              label: "Nombre del titular de la tarjeta",
              invalid: "",
              required: "",
            },
            pan: {
              label: "Número de tarjeta",
              placeholder: "",
              invalid: "Los datos ingresados no son correctos.",
              required: "Debes completar este campo correctamente.",
            },
            cvv: {
              label: "Código de seguridad",
              placeholder: "",
              invalid: "",
              required: "Debes completar este campo.",
            },
            expiration: {
              label: "Fecha de vencimiento",
              placeholder: "",
              invalid: "",
              required: "Debes completar este campo.",
            }
          },
          bank_transfer: {
            checking: 'Cuenta corriente',
            saving: 'Caja de ahorro'
          }
    },
    fr_ma: {
        api_error_message: 'Nous sommes désolé, il y a eu une erreur lors du traitement de votre requête. Veuillez réessayer dans quelques minutes.',
        accept_error_btn: 'Accepter',
        client_number: 'Numéro de client Booking.com',
        property_name: 'Nom de l’hotel',
        holder_name: 'Nom du titulaire du compte bancaire',
        document: 'CNIE',
        email: 'Email',
        invoice_number: 'Numéro de facture',
        amount: 'Montant (Dirham marocains)',
        bank_origin: 'Banque',
        voucher: 'Justificatif de paiement',
        important: 'Important',
        payment_disclaimer_1: 'Le paiement par virement bancaire comprend trois étapes importantes : ',
        payment_disclaimer_2: 'Remplissez les informations du formulaire ci-dessous et appuyer sur Envoyer',
        payment_disclaimer_3: 'Assurez-vous que les informations complétées sont correctes (ces informations vous sont également communiquées par e-mail)',
        payment_disclaimer_4: 'Procédez au paiement à travers votre plateforme bancaire en ligne ou directement auprès de votre agence bancaire, à l’aide du récapitulatif communiqué par e-mail',   
        step: 'Etape',
        invoice_disclaimer: 'Vous pouvez ajouter plusieurs factures séparées par une virgule (maximum 10 factures)',
        terms_1: 'J’accepte les',
        terms_2: ' Termes et Conditions',
        close: 'Cerrar',
        send: 'Envoyer',
        claim_bank_transfer_disclaimer:
            'Afin de retrouver votre paiement, merci d’indiquer les informations de votre email de confirmation, ainsi que le justificatif de paiement de votre banque',
        make_transfer_disclaimer: 'Faites le virement dans les trois prochaines heures.',
        read_transfer_disclaimer_1: 'Lisez attentivement les données du virement.\n',
        read_transfer_disclaimer_2: 'Nous vous suggérons de faire les virements sur votre plateforme bancaire en ligne.\n',
        read_transfer_disclaimer_3:
            ' Le virement bancaire sera traité entre le troisième et le quatrième jour ouvrable suivant la réception de votre formulaire de confirmation. Une fois traité, Booking.com en sera informé le jour ouvrable suivant.',
        reference: 'Référence',
        account_name: 'Libellé du compte',
        bank: 'Banque',
        beneficiary: 'Agence',
        entity_document: 'CNIE',
        account_type: 'Type de comptec',
        account: 'Compte',
        make_transfer: 'Faire virement',
        transfer_data: 'Données pour le virement',
        amount_usd: 'Montant',
        claim_sended: 'La réclamation a été envoyée avec succès',
        will_redirect: 'Vous allez être redirigé dans quelques instants...',
        payment_form: 'Formulaire de paiement',
        payment_choice: 'Choisissez l’option de paiement',
        form_validation: {
            only_numbers: 'Ce paramètre ne peut contenir que des chiffres',
            min_five_characters: 'Ce paramètre doit comporter au moins 5 caractères',
            must_be_ten_digits: 'La facture doit avoir 10 chiffres',
            amount_higher_than_zero: 'Le montant doit être supérieur à 0',
            amount_exceeded: 'Le montant par facture ne doit pas dépasser $',
            name_max_characters: 'Le nom est trop long, net doit pas dépasser 100 caractères',
            property_name_max_characters: 'Le nom est trop long, net doit pas dépasser 100 caractères', 
        },
        detect_message: 'Veuillez ajouter ce message en référence de votre paiement : ',
        download_manual: 'Télécharger le Guide',
        collect: 'collecte les fonds pour le compte de Booking.com.',
        continue: 'Continuar',
        card: {
            tab_title: "Tarjeta de crédito",
            title: "Pago con tarjeta de crédito",
            booking_client: "Número de cliente en booking.com",
            booking_client_placeholder: "Ingrese de 5 a 8 dígitos",
            hotel_name: "Nombre del hotel",
            document: "NIT",
            email: "Email",
            billing_title: "Facturas a pagar",
            billing_description: "Puedes pagar hasta 10 facturas al mismo tiempo. El monto máximo a pagar por factura es de ",
            currency_local: " pesos.",
            invoice_id_label: "Número de factura",
            invoice_amount_label: "Monto (COP)",
            invoice_id_placeholder: "Ingrese 10 dígitos",
            invoice_amount_placeholder: "$",
            add_invoice: "Agregar nueva factura",
            inputs_required: "Todos los campos del formulario son obligatorios.",
            total_amount: "Monto total",
            remove_tooltip: "Quitar esta factura",
            amount: {
                max: 'El monto no debe exceder los $2.000.000',
                min: 'El monto no debe ser inferior a $100'
            },
            document_min_characters: "Error de formato",
            document_max_characters: "Error de formato",
            errorSaveForm: "Se ha producido un error, por favor, intenta nuevamente.",
            document_placeholder: "Ingrese todos los dígitos juntos sin espacios, guiones, puntos ni comas e incluya el último dígito verificador"
        },
        cardPayment: {
            pay: "Pagar",
            title: "Pago con tarjeta de crédito",
            messageError: '',
            messageSuccess: '',
            returnButton: 'Volver a gestión de pagos',
            close: 'Cerrar',
            name: {
              placeholder: "Carlos García",
              label: "Nombre del titular de la tarjeta",
              invalid: "",
              required: "",
            },
            pan: {
              label: "Número de tarjeta",
              placeholder: "",
              invalid: "Los datos ingresados no son correctos.",
              required: "Debes completar este campo correctamente.",
            },
            cvv: {
              label: "Código de seguridad",
              placeholder: "",
              invalid: "",
              required: "Debes completar este campo.",
            },
            expiration: {
              label: "Fecha de vencimiento",
              placeholder: "",
              invalid: "",
              required: "Debes completar este campo.",
            }
          },
          bank_transfer: {
            checking: 'Compte courant',
            saving: 'Caisse d\'épargne'
          }
    }
}[`${language}_${country}`];
